import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { Container } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";

export const IR35PageAssessmentToolSection = ({ className }) => {
  const locale = useLocale();

  return (
    <div className={clsx(className, classes.section)}>
      <Container>
        <Heading className="mb-4" variant="white">
          <DynamicText path={`page.ir35.assessment.title.${locale}`} tag="h2" />
        </Heading>
        <DynamicHtml path={`page.ir35.assessment.text.${locale}`} className="pb-3 text-white" />
      </Container>
      <iframe width="100%" height="476" src="https://s.pointerpro.com/gravitas-ir35" />
    </div>
  );
};

IR35PageAssessmentToolSection.defaultProps = {
  className: "py-4 py-md-5 bg-primary me-md-5",
};
